import { AuthDTO } from "@/types/api/auth";
import axios, { AxiosError, AxiosHeaders, InternalAxiosRequestConfig } from "axios";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || "http://127.0.0.1:8000/api"

const readAuthFromStorage = (): AuthDTO | null => {
    if (typeof window === "undefined") return null;
    try {
        const raw = window.localStorage.getItem("auth");
        if (!raw) return null;
        console.log(JSON.parse(raw) as AuthDTO)

        return JSON.parse(raw) as AuthDTO;
    } catch (error) {
        console.warn("Failed to parse auth payload from localStorage", error);
        return null;
    }
};

const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const headers = AxiosHeaders.from(config.headers ?? {});

    // Get auth token from localStorage
    const auth = readAuthFromStorage();
    if (auth?.token) {
        headers.set("Authorization", `Bearer ${auth.token}`);
    } else {
        headers.delete("Authorization");
    }

    config.headers = headers;
    return config;
});

instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        console.log(error);
        return Promise.reject(error);
    }
);

export default instance;
